import * as pdfjs from 'pdfjs-dist';

// Copy node_modules/pdfjs-dist/build/pdf.worker.min.mjs to portal public/pdf.worker.min.mjs.
// Same-origin absolute URL works with Vite and Create React App; no ?url import needed.
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

export async function getPdfJsDocument(sourceId, sources, cache) {
  if (cache.has(sourceId)) return cache.get(sourceId);
  const source = sources.get(sourceId);
  if (!source) throw new Error('Kaynak PDF bulunamadı.');
  const task = pdfjs.getDocument({ data: source.bytes.slice() });
  const promise = task.promise.catch((error) => { cache.delete(sourceId); throw error; });
  cache.set(sourceId, promise);
  return promise;
}
